export const setChannelQueryPagination = (state, action) => {
  state.channelQuery.pagination = action.payload
}
